<template>
  <MarcoPrecios v-if="step.productos.length >= 1">
    <div slot="content">
      <div class="col1  col-lg-12">
        <div v-if="step.numPresupuesto" class="numPresupuesto">
          <span>Ref: {{ step.numPresupuesto }}</span>
        </div>
        <div class="main-title">
          <h1 class="title">{{ step.pregunta }}</h1>
        </div>
        <!-- Init Block Seguro-->
        <div v-for="producto in step.productos" :key="producto.id" class="pp">
          <div class="block-producto">
            <GarantiasDeUnProducto class="garantias" :producto="producto" />
            <div class="precio-container">
              <PrecioDeUnProducto :precios="producto.precios" />
              <div style="width:1.5rem" />
              <div class="boton" @click.prevent="siguiente(producto.id)">
                <div href="#">Selecciona producto</div>
              </div>
            </div>
          </div>
          <DetalleGarsDeUnProducto :producto="producto" />
        </div>
        <!-- End Block Seguro-->
      </div>
    </div>
    <a slot="botonAtras" href="#" @click.prevent="$router.go(-1)">Atrás</a>
  </MarcoPrecios>
  <Marco v-else>
    <div class="cl one-col position" slot="content">
      <div class="col2 " />

      <div class="col1">
        <div class="main-title">
          <h1 class="title">Aviso</h1>
        </div>

        <div class="field-row">
          <div class="field">
            <div class="wysiwyg type2">
              <p>{{ step.mensaje }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Marco>
</template>

<script>
import actions from "@/util/actions.js";
import router from "@/router";
export default {
  store: ["step"],

  methods: {
    siguiente: async function(idProducto) {
      console.log("selected " + idProducto);
      let response = await actions.selectProducto(idProducto);
      if (response.data.codigo == 0) {
        this.$emit("elegido", this.step.idPresupuesto);
      } else {
        let mensajeError = response.data.mensaje;
        if (response.data.codigo === 9999) {
          mensajeError +=
            " .Por favor, ponte en contacto con nosotros para ayudarte.";
        }
        console.log("Redirigimos a pantalla de error");
        router.push({
          name: "ShowErrorPresupuesto",
          params: {
            errorMessage: mensajeError
          }
        });
      }
      this.$emit("spinner-off");
    }
  }
};
</script>

<style lang="scss" scoped>
.pp {
  padding-bottom: 2rem;
  background-color: transparent;
}

.block-producto {
  background-color: white;
  padding: 1rem;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.precio-container {
  display: flex;
  flex-flow: row wrap;
}

.boton {
  width: 28rem;
  background-color: #e26f00;
  border-radius: 0.7rem;
  padding: 2rem;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  div {
    font-size: 2rem;
    color: white;
    text-decoration: none;
    font-weight: bold;
  }
}

.numPresupuesto {
  font-size: 2rem;
  font-weight: 400;
  color: white;
  padding-right: 1rem;
  text-align: right;
  span {
    background-color: #999;
    border-radius: 0.5rem;
    padding: 0.2rem 0.6rem 0.2rem 0.6rem;
  }
}
</style>
